function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import { useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { EnvelopeFill, Github, InfoCircleFill, Tools } from 'react-bootstrap-icons';
import { FormattedDate, FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { CONTACT_EMAIL, DB_LAST_UPDATE, DB_TOTAL_RECORDS } from '../config';
import { InlineCopy } from './InlineCopy';
import { InternalLink } from './InternalLink';
import pkg from '../../package.json';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Footer(_ref) {
  var onInformationClick = _ref.onInformationClick,
      onApiClick = _ref.onApiClick;
  var intl = useIntl();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleModalInformationClick = function handleModalInformationClick() {
    setShow(false);
    onInformationClick();
  };

  var renderModal = function renderModal() {
    return /*#__PURE__*/_jsxs(Modal, {
      show: show,
      onHide: function onHide() {
        return setShow(false);
      },
      restoreFocus: false,
      children: [/*#__PURE__*/_jsx(Modal.Header, {
        closeButton: true,
        children: /*#__PURE__*/_jsx(Modal.Title, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "footer.contact"
          })
        })
      }), /*#__PURE__*/_jsxs(Modal.Body, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "footer.contact_remark",
            values: {
              b: function b(remark) {
                return /*#__PURE__*/_jsx("strong", {
                  children: remark
                });
              },
              a: function a(text) {
                return /*#__PURE__*/_jsx(InternalLink, {
                  onClick: handleModalInformationClick,
                  children: text
                });
              }
            }
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            xs: 12,
            sm: {
              offset: 3,
              span: 6
            },
            children: /*#__PURE__*/_jsx(InlineCopy, {
              id: "input-contact",
              text: CONTACT_EMAIL,
              center: true
            })
          })
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Row, {
      className: "text-center mt-3",
      children: [/*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "footer.current_data",
          values: {
            count: /*#__PURE__*/_jsx("strong", {
              children: /*#__PURE__*/_jsx(FormattedNumber, {
                value: DB_TOTAL_RECORDS
              })
            }),
            date: /*#__PURE__*/_jsx(FormattedDate, {
              value: DB_LAST_UPDATE,
              month: "long",
              year: "numeric",
              timeZone: "UTC"
            })
          }
        })
      }), /*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsxs(InternalLink, {
          onClick: onInformationClick,
          children: [/*#__PURE__*/_jsx(InfoCircleFill, {
            className: "icon mr-2"
          }), /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "footer.informations"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsxs(Row, {
      className: "text-center mt-3",
      children: [/*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsx("em", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "footer.credit",
            values: {
              author: /*#__PURE__*/_jsx("a", {
                href: "https://florian.cassayre.me",
                target: "_blank",
                rel: "noopener",
                children: pkg.author
              }),
              a: function a(inseeData) {
                return /*#__PURE__*/_jsx("a", {
                  href: "https://www.insee.fr/fr/information/4190491",
                  target: "_blank",
                  rel: "noreferrer",
                  children: inseeData
                });
              }
            }
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsxs(InternalLink, {
          onClick: function onClick() {
            return setShow(true);
          },
          noScroll: true,
          children: [/*#__PURE__*/_jsx(EnvelopeFill, {
            className: "icon mr-2"
          }), /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "footer.contact"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsxs(InternalLink, {
          onClick: onApiClick,
          children: [/*#__PURE__*/_jsx(Tools, {
            className: "icon mr-2"
          }), /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "footer.api"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        xs: 12,
        className: "mt-2",
        children: /*#__PURE__*/_jsx("a", {
          href: pkg.repository.url.replace('.git', ''),
          target: "_blank",
          rel: "noreferrer",
          className: "link-dark",
          "aria-label": intl.formatMessage({
            id: 'footer.github'
          }),
          children: /*#__PURE__*/_jsx(Github, {
            className: "icon h2"
          })
        })
      })]
    }), renderModal()]
  });
}
Footer.propTypes = {
  onInformationClick: PropTypes.func.isRequired,
  onApiClick: PropTypes.func.isRequired
};